<ng-container *ngFor="let flag of flags; let last = last; trackBy: trackByFlag">
	<a
		mat-menu-item
		[obgInteraction]="flag.uiInteractionEvent"
		[obgRouteLink]="{ url: flag.href }"
		[obgRouteLinkOptions]="{ disableComponentSharing: true }"
		[attr.test-id]="'language-selector-' + flag.name + '-link'"
	>
		<img
			class="image-container"
			[src]="flag.image?.url"
			loading="lazy"
			[title]="flag.image?.altText || flag.name"
		/>
		<span>{{ flag.name }}</span>
	</a>
	<mat-divider *ngIf="!last"></mat-divider>
</ng-container>
